import { render, staticRenderFns } from "./OtherInfo.vue?vue&type=template&id=6f6dd5c2&"
import script from "./OtherInfo.vue?vue&type=script&lang=js&"
export * from "./OtherInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6dd5c2')) {
      api.createRecord('6f6dd5c2', component.options)
    } else {
      api.reload('6f6dd5c2', component.options)
    }
    module.hot.accept("./OtherInfo.vue?vue&type=template&id=6f6dd5c2&", function () {
      api.rerender('6f6dd5c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/OtherInfo.vue"
export default component.exports